import serviceResponseObject from './serviceResponseObject'

const URLS = {
  SUBSCRIBE: '/api/cpa/my/preferences/central',
}

export const service = {
  /**
   * Subscribe to central inspiration email
   */
  subscribe: () => {
    const payload = {
      preference: 'INFO_VECKA_EMAIL',
      active: true
    }
    return fetch(URLS.SUBSCRIBE, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(response => {
      if (response.status >= 200 && response.status < 300) {
        return 'ok'
      } else {
        const error = new Error(response.statusText)
        error.response = response
        throw error
      }
    })
  },

  /**
   * Update email address
   */
  updateEmail: async ({ email, baseUrl, publicAccessToken }) => {
    let response

    try {
      response = await fetch(`${baseUrl}/email`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${publicAccessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(email)
      })
    } catch (error) {
      return serviceResponseObject(false, '')
    }

    if (response.status >= 200 && response.status < 300) {
      return serviceResponseObject(true, await response.text())
    }
    if (response.status === 400) {
      return serviceResponseObject(false, await response.text())
    }

    return serviceResponseObject(false, '')
  },

  /**
   * Toggle save recipe
   */
  toggleSaveRecipe: async ({ recipeId, publicAccessToken, url, isSaved }) => {
    let response

    try {
      response = await fetch(`${url}/api/recipes/saved/${recipeId}`, {
        method: isSaved ? 'PUT' : 'DELETE',
        headers: {
          Authorization: `Bearer ${publicAccessToken}`,
          'Content-Type': 'application/json'
        }
      })
    } catch (error) {
      return serviceResponseObject(false, '')
    }

    if (response.status >= 200 && response.status < 300) {
      return serviceResponseObject(true, await response.text())
    }
    if (response.status === 400) {
      return serviceResponseObject(false, await response.text())
    }

    return serviceResponseObject(false, '')
  },

  /**
   * Get favorite stores
   */
   getFavoriteStores: async ({ url, publicAccessToken }) => {
    let response

    try {
      response = await fetch(`${url}/favoritestores`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${publicAccessToken}`,
          'Content-Type': 'application/json'
        }
      })
    } catch (error) {
      return serviceResponseObject(false, 'Could not get favorite stores')
    }

    // If customer has no stores, an empty result (204) will be returned
    if (response.status === 204) {
      return []
    } else if (response.status >= 200 && response.status < 300) {
      return await response.json()
    }

    if (response.status === 400) {
      return serviceResponseObject(false, await response.text())
    }

    return serviceResponseObject(false, '')
  },

  /**
   * Get store by id
   */
   searchStoreById: async ({ url, storeId, useaccountnr }) => {
    let response
    try {
      response = await fetch(`${url}/api/store/searchbyid?query=${storeId}&useaccountnr=${useaccountnr}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
    } catch (error) {
      return serviceResponseObject(false, 'Could not get store data')
    }

    if (response.status >= 200 && response.status < 300) {
      return await response.json()
    }

    if (response.status === 400) {
      return serviceResponseObject(false, await response.text())
    }

    return serviceResponseObject(false, '')
  }
}
